import {ReactComponent as FeedbackIcon} from '#/components/icons/ico_feedback.svg';
import {ModalContext} from '#/contexts/modal-provider';
import {ClassName} from '#/utils/utils';
import {FunctionComponent, useContext} from 'react';
import {useTranslation} from 'react-i18next';

export const FeedbackButton: FunctionComponent<ClassName> = ({className = ''}) => {
  // Context
  const {open} = useContext(ModalContext);

  const {t} = useTranslation('translation');

  const onClick = () => {
    open({name: 'UserFeedbackModal', props: {}});
  };

  return (
    <button
      className={`flex fixed bottom-[15px] md:bottom-[30px] right-3 sx:right-10 items-center gap-2 px-3 py-2 rounded-xl bg-black shadow-2xl hover:scale-105 transition-all ease-in-out cursor-pointer whitespace-nowrap ${className}`}
      onClick={onClick}
    >
      <FeedbackIcon className='w-6 h-6 fill-white stroke-transparent' />
      <span className='text-sm text-white font-semibold hidden md:block'>{t('actions.feedback')}</span>
    </button>
  );
};
